import Contacts from '@/components/contact/contact-list';
import ContactCreate from '@/components/contact/contact-create';
import ContactUpdate from '@/components/contact/contact-update';

const routes = [
    {
        path: '/contacts',
        name: 'contacts',
        component: Contacts,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                { text: 'Contacts' }
            ],
			requiresAuth: true
        }
    },
    {
        path: '/contacts/create',
        name: 'contactcreate',
        component: ContactCreate,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                {
                    text: 'Contacts',
					href: 'javascript:history.back()',
                },
                { text: 'Create' }
            ],
			requiresAuth: true
        }
    },
    {
        path: '/contacts/:id/update',
        name: 'contactupdate',
        component: ContactUpdate,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                {
                    text: 'Contacts',
					href: 'javascript:history.back()',
                },
                { text: 'Edit' }
            ],
			requiresAuth: true
        }
    },
];

export default routes;


// WEBPACK FOOTER //
// ./src/components/contact/routes/index.js